// @flow
import styled from 'styled-components';

export const Container: any = styled.div``;

export default Container;
